module.exports = __webpack_public_path__ + "lxy-admin/img/iPhone.57876124.png";